import { getDefaultExportFromCjs } from '../../_virtual/_commonjsHelpers.mjs';
import { _ as _createCompounder } from './_createCompounder.mjs';
import { u as upperFirst_1 } from './upperFirst.mjs';

var createCompounder = _createCompounder,
    upperFirst = upperFirst_1;

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

var startCase_1 = startCase;

const startCase$1 = /*@__PURE__*/getDefaultExportFromCjs(startCase_1);

export { startCase$1 as default };
